<template>
  <section class="footer-banner">
    <!-- Animated particles -->
    <div class="particle" v-for="n in 12" :key="n" :style="particleStyle(n)"></div>
    <div class="banner-grid"></div>

    <div class="container">
      <div class="banner-content">
        <!-- Left deco -->
        <div class="banner-deco deco-left">
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none" opacity="0.15">
            <circle cx="60" cy="60" r="55" stroke="white" stroke-width="1.5" stroke-dasharray="8 4"/>
            <circle cx="60" cy="60" r="35" stroke="white" stroke-width="1" stroke-dasharray="4 6"/>
            <circle cx="60" cy="60" r="12" fill="white" opacity="0.3"/>
          </svg>
        </div>

        <div class="banner-text">
          <div class="banner-tag">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
            开始你的AI之旅
          </div>
          <h2 class="banner-title">准备好打造您的 <span class="banner-gradient">AI团队</span> 了吗？</h2>
          <p class="banner-subtitle">
            免费注册体验，即刻开启AI之旅。无需信用卡，<br>数千家企业已在点石AI上找到增长飞轮。
          </p>

          <!-- Trust logos row -->
          <div class="trust-logos">
            <div class="logo-item" v-for="n in 5" :key="n" :style="{ opacity: 0.6 + n*0.05 }">
              <div class="logo-placeholder">LOGO{{ n }}</div>
            </div>
          </div>
        </div>

        <!-- CTA area -->
        <div class="banner-cta">
          <router-link :to="AGENTS_PLAZA" class="cta-primary-btn">
            <span>立即免费体验</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </router-link>

          <div class="cta-features">
            <div class="cta-feature" v-for="f in ctaFeatures" :key="f">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              {{ f }}
            </div>
          </div>
        </div>

        <!-- Right deco -->
        <div class="banner-deco deco-right">
          <svg width="160" height="160" viewBox="0 0 160 160" fill="none" opacity="0.12">
            <rect x="20" y="20" width="120" height="120" rx="20" stroke="white" stroke-width="1.5" stroke-dasharray="10 5"/>
            <rect x="40" y="40" width="80" height="80" rx="12" stroke="white" stroke-width="1" stroke-dasharray="6 6"/>
            <circle cx="80" cy="80" r="16" fill="white" opacity="0.2"/>
          </svg>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { AGENTS_PLAZA } from '@/constants/homeNav'

export default {
  name: 'FooterBanner',
  data() {
    return {
      AGENTS_PLAZA,
      ctaFeatures: ['免费注册，立即使用', '500+智能体开箱即用', '1000+工作流模板', '7×24小时AI在线'],
    }
  },
  methods: {
    particleStyle(n) {
      const positions = [
        { top: '10%', left: '5%', size: 6 }, { top: '20%', left: '90%', size: 10 },
        { top: '60%', left: '8%', size: 8 }, { top: '80%', left: '85%', size: 6 },
        { top: '40%', left: '50%', size: 4 }, { top: '15%', left: '40%', size: 8 },
        { top: '70%', left: '30%', size: 5 }, { top: '50%', left: '75%', size: 7 },
        { top: '30%', left: '20%', size: 9 }, { top: '85%', left: '55%', size: 5 },
        { top: '5%', left: '65%', size: 7 }, { top: '90%', left: '15%', size: 4 },
      ]
      const p = positions[(n - 1) % positions.length]
      return {
        width: p.size + 'px', height: p.size + 'px',
        top: p.top, left: p.left,
        animationDelay: (n * 0.4) + 's',
        animationDuration: (4 + (n % 3)) + 's',
      }
    }
  }
}
</script>

<style scoped>
.footer-banner {
  position: relative;
  background: linear-gradient(135deg, #1D4ED8 0%, #0284C7 40%, #0891B2 100%);
  padding: 100px 0;
  overflow: hidden;
}

.theme-dark .footer-banner {
  background: linear-gradient(135deg, #1E3A8A 0%, #1D4ED8 50%, #0284C7 100%);
}

.banner-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px);
  background-size: 56px 56px;
  pointer-events: none;
}

/* Particles */
.particle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255,255,255,0.5);
  animation: floatSlow 4s ease-in-out infinite;
  pointer-events: none;
}

.banner-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 48px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.banner-deco {
  flex-shrink: 0;
  animation: floatSlow 8s ease-in-out infinite;
}
.deco-left { animation-delay: 0s; }
.deco-right { animation-delay: 3s; }

.banner-text {
  flex: 1;
  min-width: 300px;
  color: white;
}

.banner-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: rgba(255,255,255,0.2);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 100px;
  font-size: 0.8rem;
  font-weight: 600;
  color: white;
  margin-bottom: 20px;
  backdrop-filter: blur(8px);
}

.banner-title {
  font-size: clamp(1.6rem, 3vw, 2.5rem);
  font-weight: 900;
  color: white;
  line-height: 1.2;
  margin-bottom: 16px;
  letter-spacing: -0.02em;
}

.banner-gradient {
  background: linear-gradient(135deg, #93C5FD, #67E8F9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.banner-subtitle {
  font-size: 1rem;
  color: rgba(255,255,255,0.8);
  line-height: 1.7;
  margin-bottom: 28px;
}

/* Trust logos */
.trust-logos {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.logo-item {
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 10px;
  padding: 8px 16px;
  backdrop-filter: blur(4px);
}
.logo-placeholder {
  font-size: 0.75rem;
  font-weight: 700;
  color: white;
  letter-spacing: 0.05em;
}

/* CTA */
.banner-cta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex-shrink: 0;
}

.cta-primary-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 18px 40px;
  background: white;
  color: #1D4ED8;
  border-radius: 14px;
  font-size: 1.05rem;
  font-weight: 800;
  text-decoration: none;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  transition: all 0.25s ease;
  white-space: nowrap;
}
.cta-primary-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 48px rgba(0,0,0,0.35);
  background: #F0F9FF;
}

.cta-features {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.cta-feature {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.84rem;
  color: rgba(255,255,255,0.85);
  font-weight: 500;
}
.cta-feature svg { color: #67E8F9; flex-shrink: 0; }

@media (max-width: 900px) {
  .banner-deco { display: none; }
  .banner-content { flex-direction: column; text-align: center; }
  .banner-cta { align-items: center; width: 100%; }
  .cta-features { flex-direction: row; flex-wrap: wrap; justify-content: center; }
  .trust-logos { justify-content: center; }
}
</style>
